// Cloning can result in the same errors from saving. So fallback to saving errors.

import isValidI18nKey from 'I18n/utils/isValidI18nKey';
const SAVING_ERROR_PREFIX = 'editor.form.savingError.message';
const getCloningErrorMessageKey = (prefix, key) => {
  if (key) {
    const savingErrorKey = `${SAVING_ERROR_PREFIX}.${key}`;
    const errorKey = `${prefix}.failureReasons.${key}`;
    if (isValidI18nKey(errorKey)) {
      return errorKey;
    } else if (isValidI18nKey(savingErrorKey)) {
      return savingErrorKey;
    }
  }
  return `${SAVING_ERROR_PREFIX}.UNKNOWN`;
};
export default getCloningErrorMessageKey;